import VehiclesError from './VehiclesError.js'

export default class GetBodyTypeUrlParamsVehiclesError extends VehiclesError {}
